import type { ReactNode } from "react";
import { List, Stack } from "@chakra-ui/react";

const ItemsList = ({ children }: { children: ReactNode }) => (
  <List>
    <Stack
      direction={{ base: "row", md: "column" }}
      align="left"
      spacing={{ base: 4, md: 8 }}
      overflow="scroll"
      sx={{
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      {children}
    </Stack>
  </List>
);

export default ItemsList;
